﻿import ReduxThunk from 'redux-thunk';
import { createStore, combineReducers, Store, applyMiddleware } from 'redux';
import { EpiContext, UpdateEpiContextActionTypes } from '../../Shared/Scripts/Store/EpiContext/Types';
import { epiContextReducer } from '../../Shared/Scripts/Store/EpiContext/Reducers';
import { stegVisningReducer } from '../../Shared/Scripts/Store/StegVisning/Reducers';
import { EpiAppStateMedSteg } from '../../Shared/Scripts/Store/Types';
import VeilederNordenDto from '../Models/VeilederNordenDto';
import { valgReducer } from './Valg/Reducers';
import { resultatReducer } from './Resultat/Reducers';
import { satserReducer } from './Satser/Reducers';

const rootReducer = combineReducers<VeilederNordenAppState>({
    valg: valgReducer,
    epiContext: (
        state: EpiContext<VeilederNordenDto> | undefined,
        action: UpdateEpiContextActionTypes<VeilederNordenDto>,
    ): EpiContext<VeilederNordenDto> => epiContextReducer(state, action),
    stegVisning: stegVisningReducer,
    resultat: resultatReducer,
    satser: satserReducer, 
});

export type VeilederNordenAppState = EpiAppStateMedSteg<VeilederNordenDto> & {
    valg: ReturnType<typeof valgReducer>;
    resultat: ReturnType<typeof resultatReducer>;
    satser: ReturnType<typeof satserReducer>; 
};

export default function configureStore(): Store<VeilederNordenAppState> {
    return createStore(rootReducer, applyMiddleware(ReduxThunk));
}